import Provider from './Provider.vue'

export default Provider
